import type { Breakpoints } from '@trmediaab/zebra';

const breakpoints: string[] & {
  sm?: string;
  md?: string;
  lg?: string;
  xl?: string;
} = ['468px', '768px', '1024px', '1367px'];

breakpoints['sm'] = breakpoints[0];
breakpoints['md'] = breakpoints[1];
breakpoints['lg'] = breakpoints[2];
breakpoints['xl'] = breakpoints[3];

export default breakpoints as Breakpoints;
